import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div<{ $hasLabel?: boolean }>`
  --super-splash-frame-padding-inline: 16px;

  margin-block: -8px 24px;
  /* Pull the frame out of ContentContainer's 20px page gutter
     (apps/app/pages/home/styles.tsx) so the frame sits 12px from the screen
     edge on mobile. */
  margin-inline: calc(12px - 20px);
  /* On mobile, keep the frame's top spacing only when the label row exists;
     without it the widget content sits flush with the top border. */
  padding-block: ${({ $hasLabel = false }) => ($hasLabel ? "12px" : "0")} 16px;
  padding-inline: var(--super-splash-frame-padding-inline);

  border: 1px solid #888888;

  ${theme.breakpoints.up("tablet")} {
    --super-splash-frame-padding-inline: 24px;

    margin-block: -16px 24px;
    margin-inline: 0;
    padding-block: 16px;
  }

  ${theme.breakpoints.up("desktop")} {
    /* ContentContainer's margin-block-start is 24px on desktop, so pull the
       frame up 8px to keep the top border 16px from the content above. */
    margin-block-start: -8px;
  }
`;
